export const RXELEMENT_TEXTS = {
  quickSearchSynthesisPlannerInfoDialogTitle: 'Synthesis Planner',
  synthesizeAlternativeInfoDialogText:
    'The selected structure will be ' +
    'searched as product in Reaxys to find corresponding reactions, which ' +
    'then allow you to start a synthesis plan.',
  quickSearchSynthesisPlannerInfoDialogButton: 'Ok',
  // eslint-disable-next-line no-useless-concat
  synthesizeSimilarAlternativeInfoDialogText: 'No reactions found. ' + 'Do you want to find reactions for similar substances?',
  noResultsDueToLicense:
    "Reaxys didn't find a result that matched your query. " +
    'Please note that your license only provides access to the Reaxys Medicinal Chemistry content.',
  noResultsTitle: 'Sorry, Reaxys found no results',
  yes: 'Yes',
  cancel: 'Cancel',
  ok: 'OK',
};
export const REACTION_ADDITIONAL_INFO_VIEW_MODES = {
  reactants: [
    {
      order: 0,
      id: 'stage',
      title: 'Stage',
      stages: true,
    },
    {
      order: 1,
      id: 'role',
      title: 'Role',
      roles: true,
    },
    {
      order: 2,
      id: 'name',
      title: 'Name',
    },
    {
      order: 3,
      id: 'compoundName',
      title: 'Compound Name',
    },
    {
      order: 4,
      id: 'amount',
      title: 'Amount',
      appendix: 'mol',
      appendixIgnoreIf: /g|mol/gi,
    },
    {
      order: 5,
      id: 'volume',
      title: 'Volume',
      appendix: 'l',
      appendixIgnoreIf: /ml/gi,
    },
    {
      order: 6,
      id: 'form',
      title: 'Form',
    },
    {
      order: 7,
      id: 'color',
      title: 'Color',
    },
    {
      order: 8,
      id: 'equivalents',
      title: 'Equivalents',
    },
    {
      order: 9,
      id: 'sample',
      title: 'Sample',
    },
    {
      order: 10,
      id: 'comments',
      title: 'Comment',
    },
  ],
  products: [
    {
      order: 0,
      id: 'stage',
      title: 'Stage',
      stages: true,
    },
    {
      order: 1,
      id: 'role',
      title: 'Role',
      roles: true,
    },
    {
      order: 2,
      id: 'name',
      title: 'Name',
    },
    {
      order: 3,
      id: 'compoundName',
      title: 'Compound Name',
    },
    {
      order: 4,
      id: 'yieldNumber',
      title: 'Yield',
      appendix: '%',
    },
    {
      order: 5,
      id: 'conversion',
      title: 'Conversion',
    },
    {
      order: 6,
      id: 'purity',
      title: 'Purity',
      appendix: '%',
    },
    {
      order: 7,
      id: 'enantiomericPurity',
      title: 'Enantiomeric Purity',
    },
    {
      order: 8,
      id: 'amount',
      title: 'Amount',
      appendix: 'mol',
      appendixIgnoreIf: /g|mol/gi,
    },
    {
      order: 9,
      id: 'form',
      title: 'Form',
    },
    {
      order: 10,
      id: 'color',
      title: 'Color',
    },
    {
      order: 11,
      id: 'equivalents',
      title: 'Equivalents',
    },
    {
      order: 12,
      id: 'sample',
      title: 'Sample',
    },
    {
      order: 13,
      id: 'comments',
      title: 'Comment',
    },
  ],
};
export const STAGES_COLORS = ['#83e6a4', 'rgba(113, 194, 132, 0.51)', 'rgba(113, 194, 132, 0.28)'];

export const SUPPLIER_INFO_ITEMS = {
  // Provide preferred order
  default: [
    { name: 't1suppliers', title: 'Supplier (Tier1):' },
    { name: 't2suppliers', title: 'Supplier (Tier2):' },
    { name: 't3suppliers', title: 'Supplier (Tier3):' },
    { name: 't4suppliers', title: 'Supplier (Tier4):' },
    { name: 't5suppliers', title: 'Supplier (Tier5):' },
  ],
  17: [
    { name: 'qmSupplierName', title: 'Supplier Name:' },
    { name: 'qmBuildingBlockSource', title: 'Source of Building Block:' },
    { name: 'qmSourceId', title: 'Source ID:' },
    { name: 'qmCncIdFromSams', title: 'Supplier CNC ID from SAMS:' },
    { name: 'qmLocation', title: 'Location:' },
  ],
  18: [
    { name: 'msCatalog', title: 'Catalog:' },
    { name: 'msAvailableQuantityFlag', title: 'Available in 250 mg quantity:' },
    { name: 'msAvailableTwoWeeksFlag', title: 'Available in 2 weeks or less:' },
  ],
  19: [
    { name: 'qmSupplierName', title: 'Store:' },
    { name: 'qmSourceId', title: 'Lundbeck Reagent ID:' },
    { name: 'qmLocation', title: 'ID and Amount:' },
    { name: 'customInfo1', title: 'Additional Information:' },
  ],
};
export const COMPOUND_ID_PREFIXES = {
  17: 'SAMS', // Quick Monomers
  18: 'SAMS', // Market Select
};
export const METABOLIZATION_GROUPS_HEADERS = [
  {
    id: 'species',
    order: 0,
    title: 'Species',
  },
  {
    id: 'route',
    order: 1,
    title: 'Route',
  },
  {
    id: 'excretion',
    order: 2,
    title: 'Excretion',
  },
];

export const SUBSTANCE_DETAILS_TOOLTIPS = {
  19: {
    id: 'Lundbeck Compound ID',
  },
};
